import React, { useState, useEffect, useRef } from 'react'
import Modal from 'antd/es/modal'
import Button from 'components/button'
import Notification from 'antd/es/notification'
import axios from 'axios'
import Loader from 'components/loader'

// Models
import { Employee } from 'models'

// Styles
import './style.scss'

type Props = {
  visible: Employee | undefined
  onSave: (values: { card_image: any; userId: string }) => void
  onCancel: () => void
}

export const AddTaxCardModal = (props: Props) => {
  const [taxCard, setTaxCard] = useState<string | undefined>()
  const [loadingTaxCard, setLoadingTaxCard] = useState<any>(null)
  const [existingTaxCard, setExistingTaxCard] = useState<string | undefined>()
  const [loadingExistingTaxCard, setLoadingExistingTaxCard] = useState<boolean>(true)
  const [uploadingTaxCard, setUploadingTaxCard] = useState<boolean>(false)
  const [showNotPdfError, setShowNotPdfError] = useState<boolean>(false)
  const refInput = useRef<HTMLInputElement>(null)

  const onFinish = () => {
    try {
      setUploadingTaxCard(true)
      if (props.visible?._id) {
        props.onSave({ card_image: taxCard, userId: props.visible?._id })
      }
    } catch (e) {
      console.log(e)
      Notification.error({ message: JSON.stringify(e) })
    }
  }

  useEffect(() => {
    clear()
  }, [props.visible])

  const clear = () => {
    setUploadingTaxCard(false)
    setExistingTaxCard(undefined)
    setTaxCard(undefined)
    setShowNotPdfError(false)
    if (refInput.current) {
      refInput.current.value = ''
    }
  }

  const getBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  const onTaxCardChange = (e: any) => {
    try {
      if (e.target.files[0]) {
        if (e.target.files[0].type.includes('pdf')) {
          setLoadingTaxCard(true)
          setShowNotPdfError(false)
          getBase64(e.target.files[0]).then((data) => {
            if (typeof data === 'string') {
              setTaxCard(data)
              setLoadingTaxCard(false)
            }
          })
        } else {
          setShowNotPdfError(true)
          Notification.error({ message: 'Tiedoston muoto väärä, valitse .pdf tiedosto!', placement: 'topRight' })
        }
      }
    } catch (e) {
      setLoadingTaxCard(false)
      Notification.error({ message: 'Verokortin lataaminen epäonnistui', placement: 'bottomLeft' })
    }
  }

  const getExistingTaxCard = async () => {
    setLoadingExistingTaxCard(true)
    if (props.visible?.tax_card_last_update) {
      try {
        const { data } = (await axios.get(global.Config.backendUri + `/userTaxCard/${props.visible._id}`)) as any
        const { card_image } = data
        setExistingTaxCard(card_image)
      } catch (e) {
        Notification.error({ message: 'Verokorttia ei saatu ladattua', placement: 'bottomLeft' })
        setExistingTaxCard(undefined)
      }
    } else {
      setExistingTaxCard(undefined)
    }
    setLoadingExistingTaxCard(false)
  }

  useEffect(() => {
    getExistingTaxCard()
  }, [props.visible])

  const GetDownloadLink = () => {
    if (existingTaxCard && props.visible && props.visible?.tax_card_last_update) {
      const linkName = `${props.visible.first_name}_${props.visible.last_name}_verokortti.pdf`
      return (
        <a className="download-tax-card" download={linkName} style={{ borderBottom: '2em' }} href={existingTaxCard}>
          <Button
            label={'Lataa' + ' ' + linkName}
            color="green"
            style={{ borderBottom: '2em', width: '250px' }}
            onClick={() => {}}
          />
        </a>
      )
    }
    return <></>
  }

  return (
    <Modal
      visible={props.visible ? true : false}
      title={`${props.visible?.first_name} ${props.visible?.last_name} | Verokortti`}
      onCancel={() => {
        props.onCancel()
      }}
      closable={false}
      closeIcon={false}
      footer={
        <Button.ButtonGroup style={{ justifyContent: 'flex-end' }}>
          <Button
            label={taxCard ? 'Peruuta' : 'Sulje'}
            disabled={uploadingTaxCard}
            onClick={() => {
              clear()
              props.onCancel()
            }}
            color="default"
          />
          {taxCard && (
            <Button
              disabled={uploadingTaxCard}
              label="Tallenna"
              color="green"
              onClick={() => {
                onFinish()
              }}
            />
          )}
        </Button.ButtonGroup>
      }
    >
      <div className="c-tax-card__wrapper">
        {uploadingTaxCard && <Loader label="Päivitetään verokorttia" />}
        {loadingExistingTaxCard && <Loader label="Ladataan verkorttia" />}
        {!loadingExistingTaxCard && !uploadingTaxCard && (
          <div>
            {!taxCard && <GetDownloadLink />}
            {taxCard && 'Verokortin lataaminen onnistui. Talletaanko uusi verokortti?'}
            {!taxCard && (
              <Button
                style={{ marginTop: '1em', width: '250px' }}
                color="red"
                label="Lisää uusi verokortti"
                onClick={() => {
                  refInput.current?.click()
                }}
              />
            )}
            <div className="pdf-input-container">
              <input
                ref={refInput}
                type="file"
                name="file"
                disabled={loadingTaxCard}
                onChange={(e) => {
                  onTaxCardChange(e)
                }}
                style={{ opacity: 0 }}
              />
              {showNotPdfError && <p className="notpdf-error">Tiedoston muoto väärä, valitse .pdf tiedosto!</p>}
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default AddTaxCardModal
